import { render, staticRenderFns } from "./FullDefine_Desktop.vue?vue&type=template&id=35e45814&scoped=true&"
import script from "./FullDefine_Desktop.vue?vue&type=script&lang=js&"
export * from "./FullDefine_Desktop.vue?vue&type=script&lang=js&"
import style0 from "./FullDefine_Desktop.vue?vue&type=style&index=0&id=35e45814&prod&lang=css&"
import style1 from "./FullDefine_Desktop.vue?vue&type=style&index=1&id=35e45814&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e45814",
  null
  
)

export default component.exports